import { flashItems } from "@/mocks/kanliao";

const typeStyle: Record<string, string> = {
  路透: "bg-background-200 text-foreground-700",
  商务: "bg-accent-100 text-accent-800",
  直播: "bg-primary-100 text-primary-700",
  行程: "bg-accent-200/60 text-accent-900",
  综艺: "bg-secondary-200/60 text-foreground-800",
  杂志: "bg-background-200 text-foreground-700",
  互动: "bg-primary-100 text-primary-700",
  音乐: "bg-accent-100 text-accent-800",
  红毯: "bg-primary-100 text-primary-700",
  剧组: "bg-background-200 text-foreground-700",
};

export default function FlashFeed() {
  return (
    <section id="flash" className="border-t border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-widest text-accent-700">
              <i className="ri-flashlight-fill" />
              FLASH · 速递
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              5看料速递快讯，实时滚动
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              短平快的更新速递，按时间密排。想蹲的瓜，刷新就有新动静。
            </p>
          </div>
          <a
            href="#peek"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-accent-700 hover:text-accent-800"
          >
            查看待落地预告
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {flashItems.map((f, i) => (
            <a
              href="#scoop"
              key={i}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 transition-colors hover:border-accent-300 hover:bg-accent-50/40"
            >
              <span className="w-12 shrink-0 whitespace-nowrap font-mono text-[13px] font-semibold text-accent-700">
                {f.time}
              </span>
              <span
                className={
                  "shrink-0 whitespace-nowrap rounded-md px-2 py-0.5 text-[11px] font-semibold " +
                  (typeStyle[f.type] || typeStyle["路透"])
                }
              >
                {f.type}
              </span>
              <span className="min-w-0 flex-1 truncate text-[13px] text-foreground-800 transition-colors group-hover:text-foreground-950">
                {f.text}
              </span>
              <span className="flex shrink-0 items-center gap-1 text-[11px] text-foreground-500">
                <i className="ri-fire-fill text-primary-500" />
                {f.hot}
              </span>
            </a>
          ))}
        </div>

        <div className="mt-6 flex justify-center">
          <button
            type="button"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
          >
            加载更多速递
            <i className="ri-loader-4-line" />
          </button>
        </div>
      </div>
    </section>
  );
}